import React from "react"

const Reshet=()=>{
   return (
     <h1>Reshet</h1>
   )
}

export default Reshet